"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.recommendPasskeysShownLocalStorageKey = exports.knownPasskeyUserLocalStorageKey = exports.hasAcknowledgedPasskeysLocalStorageKey = void 0;
const knownPasskeyUserLocalStorageKey = exports.knownPasskeyUserLocalStorageKey = 'bhr_known_passkey_user';
const recommendPasskeysShownLocalStorageKey = exports.recommendPasskeysShownLocalStorageKey = 'bhr_recommend_passkeys_shown';
const hasAcknowledgedPasskeysLocalStorageKey = exports.hasAcknowledgedPasskeysLocalStorageKey = 'bhr_acknowledged_passkeys';